import { useEffect, useRef, useState } from "react";
import useSound from "use-sound";
import { useIncomingCall } from "./useIncomingCall";

const useAudio = (url) => {
    const [play, { stop }] = useSound(url);

    return { play, stop };
};

const useRinging = () => {
    const { play, stop } = useAudio("/ring2.mp3");
    const { ringing } = useIncomingCall();

    useEffect(() => {
        if (ringing) {
            play();
        } else {
            stop();
        }
    }, [play, ringing, stop]);
};

export { useRinging };
